import React from "react";
import Editor from "@monaco-editor/react";

/**
 * JSON Editor Panel (Monaco-based)
 * Center panel tab for raw JSON editing
 */
export default function JsonEditorPanel({ value, onChange, isLoading, isInvalid }) {
  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-indigo-500 border-t-transparent"></div>
          <p className="mt-3 text-slate-400 text-sm">설정 로딩 중...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col">
      <div className={`flex-1 ${isInvalid ? 'ring-2 ring-red-500' : ''}`}>
        <Editor
          height="100%"
          defaultLanguage="json"
          theme="vs-dark"
          value={value}
          onChange={onChange}
          options={{
            minimap: { enabled: true },
            fontSize: 13,
            lineNumbers: "on",
            scrollBeyondLastLine: false,
            automaticLayout: true,
            tabSize: 2,
            wordWrap: "on",
            formatOnPaste: true,
            formatOnType: true,
          }}
        />
      </div>
      {isInvalid && (
        <div className="px-4 py-2 bg-red-900/30 border-t border-red-500/50 text-red-400 text-sm">
          ⚠️ JSON 구문 오류: 유효하지 않은 형식입니다
        </div>
      )}
    </div>
  );
}
